import { gql } from "@apollo/client";

export const PROMO_DEDUCTION_MATCH_SUMMARY_FRAGMENT = gql`
  fragment PromoDeductionMatchSummaryFields on PromoDeductionMatchSummaryType {
    matchResultId
    deductionId
    runAt
    resultCreatedAt
    matchSummary {
      isBestMatch
      matchStatus
      confidenceScore
      rawScore
      maxApplicableScore
      displayMatchStatus
      appliedAt
      applicationSource
    }
    promotion {
      promoEventId
      promoName
      retailerName
      purchaserName
      promoStartDate
      promoEndDate
      notes
      type {
        promoTypeId
        promoTypeName
        promoTypeCode
        promoTypeKey
      }
      status {
        promoStatusId
        promoStatusName
        promoStatusKey
      }
      financials {
        committedBudget
        previouslyClaimed
        remainingOpenBalance
      }
    }
    scoringPhases {
      phase1 {
        purchaserScore
        retailerScore
        totalScore
        statusPassed
      }
      phase2 {
        score
        dateMethod
      }
      phase3 {
        score
        typeAligned
      }
      phase4 {
        score
        coverageRatio
        matchedItems
        totalItems
        matchMethod
      }
      phase5 {
        score
        allowanceAligned
        unitDiscountAligned
        balanceSufficient
      }
    }
    criteriaAlignment {
      purchaserAligned
      retailerAligned
      dateInWindow
      typeAligned
      skuFullyCovered
      allowanceAligned
      discountAligned
    }
    systemFlags {
      isDuplicateFlag
      isBalanceInsufficientFlag
      isLowCoverageFlag
      isHeaderOnlyMatch
    }
    stepLog {
      rule
      input
      phase
      points
      outcome
      description
    }
  }
`;
